import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Draggable from 'react-draggable';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { Field } from 'redux-form';

import Menu from 'components/common/Menu';
import DeleteMenu from 'components/common/DeleteMenu';
import TextField from 'components/fields/TextField';
import IconButton from 'components/common/IconButton';
import IconMoveVert from 'components/icons/IconMoveVert';
import IconRemoveSign from 'components/icons/IconRemoveSign';

import * as validate from 'utils/validate';

const styles = theme => ({
  root: {
    '& + $root': {
      marginTop: 8,
    },
  },
  gridShrink: {
    width: 170,
    maxWidth: 170,
    flexBasis: 170,
    paddingRight: 5,
  },
  buttonMove: {
    margin: -9,
  },
  buttonRemove: {
    color: theme.palette.validation[500],
  },
  iconRemoveSign: {
    width: 20,
    height: 20,
  },
  iconMoveVert: {
    width: 10,
    height: 16,
  },
  draggable: {
    position: 'relative',
  },
  draggableDragged: {
    zIndex: 10,
  },
  draggableContentWithTransition: {
    backgroundColor: theme.palette.common.white,
    transition: theme.transitions.create(['transform'], {
      duration: theme.transitions.duration.short,
    }),
  },
});

class TemplatesCreateEditFormFieldMenuChoice extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dragged: false,
      position: null,
      bounds: null,
      anchorEl: null,
    };

    this.onMenuClose = this.onMenuClose.bind(this);
    this.onRemoveButtonClick = this.onRemoveButtonClick.bind(this);
    this.onRemoveCancel = this.onRemoveCancel.bind(this);
    this.onRemoveSubmit = this.onRemoveSubmit.bind(this);
    this.onDraggableDataChange = this.onDraggableDataChange.bind(this);
    this.onStartDrag = this.onStartDrag.bind(this);
    this.onDrag = this.onDrag.bind(this);
    this.onStopDrag = this.onStopDrag.bind(this);
  }

  componentDidMount() {
    this.draggableDataChangeTimeout = setTimeout(() => {
      this.onDraggableDataChange();
    }, 100);
  }

  componentDidUpdate(prevProps) {
    const { timestamp } = this.props;
    if (timestamp !== prevProps.timestamp) {
      this.draggableDataChangeTimeout = setTimeout(() => {
        this.onDraggableDataChange();
      }, 100);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.draggableDataChangeTimeout);
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onRemoveButtonClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
    });
  }

  onRemoveCancel() {
    this.setState({ anchorEl: null });
  }

  onRemoveSubmit() {
    this.props.onRemove();
    this.setState({ anchorEl: null });
  }

  onDraggableDataChange() {
    const { boundsSelector, index, onDraggableDataChange } = this.props;
    if (boundsSelector) {
      const draggableRefDOMRect = this.draggableRef.getBoundingClientRect();
      const boundsDOMRect = document.querySelector(boundsSelector).getBoundingClientRect();
      const left = Math.round(boundsDOMRect.left - draggableRefDOMRect.left);
      const top = Math.round(boundsDOMRect.top - draggableRefDOMRect.top);
      const right = Math.round((boundsDOMRect.width - draggableRefDOMRect.width) + left);
      const bottom = Math.round((boundsDOMRect.height - draggableRefDOMRect.height) + top);
      const data = {
        bounds: { left, top, right, bottom },
        width: draggableRefDOMRect.width,
        height: draggableRefDOMRect.height,
      };
      const draggableData = {};
      draggableData[index] = data;
      this.setState(data);
      onDraggableDataChange(draggableData);
    }
  }

  onStartDrag(event, data) {
    const { onStartDrag, index } = this.props;
    const { bounds, width, height } = this.state;
    this.onDraggableDataChange();
    this.setState({ dragged: true });
    if (onStartDrag) {
      onStartDrag({
        x: data.x - bounds.left,
        y: data.y - bounds.top,
        width,
        height,
        defaultX: -bounds.left,
        defaultY: -bounds.top,
        index,
      });
    }
  }

  onDrag(event, data) {
    const { onDrag, index } = this.props;
    const { bounds, width, height } = this.state;
    if (onDrag) {
      onDrag({
        x: -bounds.left,
        y: data.y - bounds.top,
        width,
        height,
        defaultX: -bounds.left,
        defaultY: -bounds.top,
        index,
      });
    }
  }

  onStopDrag(event, data) {
    const { onStopDrag, index } = this.props;
    const { bounds, width, height } = this.state;
    this.setState({
      dragged: false,
      position: {
        x: 0,
        y: 0,
      },
    });
    if (onStopDrag) {
      onStopDrag({
        x: data.x - bounds.left,
        y: data.y - bounds.top,
        width,
        height,
        defaultX: -bounds.left,
        defaultY: -bounds.top,
        index,
      });
    }
  }

  render() {
    const {
      input,
      onRemove,
      dragDisabled,
      withTransition,
      offsetY,
      classes,
    } = this.props;
    const { anchorEl, bounds, position, dragged } = this.state;
    const open = Boolean(anchorEl);

    return (
      <Draggable
        axis="y"
        handle={`.${classes.buttonMove}`}
        disabled={dragDisabled}
        {...bounds ? { bounds } : {}}
        {...position ? { position } : {}}
        onStart={this.onStartDrag}
        onDrag={this.onDrag}
        onStop={this.onStopDrag}
      >
        <div
          className={classNames(classes.draggable, {
            [classes.draggableDragged]: dragged,
          })}
          ref={(draggableRef) => {
            this.draggableRef = draggableRef;
          }}
        >
          <div
            className={classNames({
              [classes.draggableContentWithTransition]: withTransition,
            })}
            style={{ transform: `translateY(${offsetY}px)` }}
          >
            <Grid
              className={classes.root}
              container
              spacing={0}
              wrap="nowrap"
              alignItems="center"
            >
              <Grid
                className={classes.gridShrink}
                item
                xs={12}
              >
                <Field
                  id={input.name}
                  name={input.name}
                  component={TextField}
                  validate={[validate.required]}
                  errorPlacement="top"
                  fullWidth
                />
              </Grid>
              <Grid item>
                <IconButton
                  disabled={!onRemove}
                  className={classNames(classes.button, classes.buttonRemove)}
                  aria-label="Remove"
                  aria-owns={open ? `${input.name}-remove-menu` : null}
                  aria-haspopup="true"
                  onClick={this.onRemoveButtonClick}
                  tooltipContent={onRemove ? 'Delete' : null}
                >
                  <IconRemoveSign className={classes.iconRemoveSign} />
                </IconButton>
                <Menu
                  id={`${input.name}-remove-menu`}
                  anchorEl={anchorEl}
                  open={open}
                  onClose={this.onMenuClose}
                  list={false}
                >
                  <DeleteMenu
                    text="Are you sure you want to delete this option?"
                    onCancel={this.onRemoveCancel}
                    onSubmit={this.onRemoveSubmit}
                  />
                </Menu>
              </Grid>
              <Grid item>
                <IconButton
                  className={classes.buttonMove}
                  disabled={dragDisabled}
                  tooltipContent={!dragDisabled ? 'Drag it to Change Position' : null}
                >
                  <IconMoveVert className={classes.iconMoveVert} />
                </IconButton>
              </Grid>
            </Grid>
          </div>
        </div>
      </Draggable>
    );
  }
}

TemplatesCreateEditFormFieldMenuChoice.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  onRemove: PropTypes.func,
  boundsSelector: PropTypes.string,
  dragDisabled: PropTypes.bool,
  onStartDrag: PropTypes.func,
  onDrag: PropTypes.func,
  onStopDrag: PropTypes.func,
  onDraggableDataChange: PropTypes.func.isRequired,
  withTransition: PropTypes.bool,
  offsetY: PropTypes.number,
  timestamp: PropTypes.number.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    gridShrink: PropTypes.string.isRequired,
    buttonMove: PropTypes.string.isRequired,
    buttonRemove: PropTypes.string.isRequired,
    iconRemoveSign: PropTypes.string.isRequired,
    iconMoveVert: PropTypes.string.isRequired,
    draggable: PropTypes.string.isRequired,
    draggableDragged: PropTypes.string.isRequired,
    draggableContentWithTransition: PropTypes.string.isRequired,
  }).isRequired,
};

TemplatesCreateEditFormFieldMenuChoice.defaultProps = {
  onRemove: null,
  boundsSelector: null,
  dragDisabled: false,
  onStartDrag: null,
  onDrag: null,
  onStopDrag: null,
  offsetY: 0,
  withTransition: false,
};

export default withStyles(styles)(TemplatesCreateEditFormFieldMenuChoice);



// WEBPACK FOOTER //
// ./src/components/settings/TemplatesCreateEditForm/TemplatesCreateEditFormFieldMenuChoice.js